// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import Vuex from 'vuex'
import VueI18n from 'vue-i18n'
import store from './store/store'
import Vant from 'vant'
import './assets/css/aui/aui.css'
import './assets/css/aui/aui-flex.css'
import './assets/css/aui/aui-pull-refresh.css'
import './assets/css/my-mint.css'
import './assets/css/my-iconfont/my-iconfont.css'
import './assets/css/common.css'
import 'vant/lib/index.css'
import http from './http/index'
import permiss from './permiss/index'
import Filters from './assets/js/filters/filters'
// import wx from 'weixin-js-sdk'

Vue.config.productionTip = false

Vue.prototype.$http = http
Vue.prototype.$permiss = permiss
/**
 * 注册通用过滤器
 */
Object.keys(Filters).forEach(key => {
  Vue.filter(key, Filters[key])
})
/**
 * 所有url拦截
 */
router.beforeEach((to, from, next) => {
  if (to.query.userInfor) {
    let {id, nickname, username, token, refreshToken, superAdmin, roleName, sourceType} = JSON.parse(to.query.userInfor)
    store.state.loginUserInfor = {id, nickname, username, token, refreshToken, superAdmin, roleName, sourceType}
    if (window.__wxjs_environment === 'miniprogram') {
      window.localStorage.wmUserInfo = JSON.stringify({ userId: username, projectVersion: '1.0.1' })
      localStorage.setItem('loginUserInfor', JSON.stringify({id, nickname, username, token, refreshToken, superAdmin, roleName, sourceType}))
    }
  }
  if (to.query.host) {
    let host = to.query.host
    store.state.host = host
    if (host === 'cblzhgd.jvcom.cn') {
      store.commit('setIsCBLCustomer', true)
    } else {
      store.commit('setIsCBLCustomer', false)
    }
    localStorage.setItem('host', host)
  }
  if (to.query.neutral) {
    // neutral 1: 中性小程序，其他都不是中性小程序
    let neutral = to.query.neutral
    if (neutral === '1') {
      store.commit('setIsNeutral', true)
    } else {
      store.commit('setIsNeutral', false)
    }
  } else {
    store.commit('setIsNeutral', false)
  }
  let n = navigator.userAgent
  console.log(n)
  console.log(window.__wxjs_environment)
  if (n.indexOf('Android') > -1 || n.indexOf('Linux') > -1 || n.indexOf('Windows Phone') > -1 || n.indexOf('Google Phone') > -1) {
    if (n.indexOf('miniProgram') > -1) {
      store.state.isWXMiniProgramEnv = true
    } else {
      store.state.isWXMiniProgramEnv = false
    }
  } else if (n.indexOf('iPhone') > -1) {
    if (window.__wxjs_environment === 'miniprogram') {
      store.state.isWXMiniProgramEnv = true
    } else {
      store.state.isWXMiniProgramEnv = false
    }
  } else {
    store.state.isWXMiniProgramEnv = false
  }
  // 回到项目列表时，初始化当前项目的id
  if (to && to.name === 'ProjectList') {
    store.state.currentProjectId = ''
  } else if (to.query.projectId) {
    // 如果是小程序的webview打开项目
    store.state.currentProjectId = to.query.projectId
  }
  next()
})
Vue.use(Vant)
/* eslint-disable no-new */
Vue.use(VueI18n)
const i18n = new VueI18n({
  locale: 'zh',
  messages: {
    'zh': require('@/assets/languages/zh.json'),
    'en': require('@/assets/languages/en.json')
  }
})
Vue.use(Vuex)
window.vm = new Vue({
  el: '#app',
  router,
  i18n,
  store,
  components: { App },
  template: '<App/>'
})
